/** @file Renames an animation (one @DIR suffix allowed); mixDefaults sides and direction-fix keys follow. */
import { defineCommand } from '../defineCommand';
import { defineRename } from '../_shared/defineRename';
import { renameFixBases } from './renameFixBases';
import { renameMixSides } from './renameMixSides';

const rename = defineRename({
  domain: 'animation',
  kind: 'animation',
  description: 'Rename an animation (name or id; `<base>@<DIR>` allowed); mixDefaults pairs that named it follow the new name, and direction-fix keys of its base follow once no animation keeps the old base.',
});

/** animation.rename: defineRename, then mix sides and fix keys follow; the current name is an INFO no-op (W2-31). */
export const command = defineCommand({
  ...rename,
  apply(draft, input, ctx) {
    const from = draft.animations[ctx.resolve('animation', input.target)]?.name ?? input.target;
    if (from === input.name) {
      ctx.warnings.push({ code: 'INFO', message: `the animation already is named ${from}; nothing changed`, params: { name: from }, path: 'name' });
      return;
    }
    rename.apply(draft, input, ctx);
    const dropped = renameMixSides(draft, from, input.name);
    if (dropped > 0) {
      ctx.warnings.push({ code: 'INFO', message: `${dropped} mix defaults collided with existing pairs and were dropped`, params: { dropped }, path: 'name' });
    }
    const droppedFixes = renameFixBases(draft, from, input.name);
    if (droppedFixes > 0) {
      ctx.warnings.push({ code: 'INFO', message: `${droppedFixes} direction-fix keys collided with existing keys and were dropped`, params: { droppedFixes }, path: 'name' });
    }
  },
});
